import React from 'react'
export const PublicIndexContext = React.createContext()
